// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

export const POST_LOGIN_REDIRECT_ALLOWLIST = {
  'silver-alpha': '/silver-alpha',
} as const;

export type PostLoginRedirectToken = keyof typeof POST_LOGIN_REDIRECT_ALLOWLIST;

export const POST_LOGIN_REDIRECT_TOKENS = Object.keys(
  POST_LOGIN_REDIRECT_ALLOWLIST,
) as PostLoginRedirectToken[];

export interface PostLoginRedirect {
  readonly token: PostLoginRedirectToken;
  readonly path: string;
}

const isPostLoginRedirectToken = (value: string): value is PostLoginRedirectToken =>
  value in POST_LOGIN_REDIRECT_ALLOWLIST;

export const resolvePostLoginRedirect = (
  raw: string | null | undefined,
): PostLoginRedirect | null => {
  if (raw === null || raw === undefined) return null;

  const trimmed = raw.trim();

  if (!trimmed) return null;

  let decoded: string;

  try {
    decoded = decodeURIComponent(trimmed).trim();
  } catch {
    return null;
  }

  if (!decoded || decoded.includes('/') || decoded.includes('\\')) return null;

  if (!isPostLoginRedirectToken(decoded)) return null;

  return {
    token: decoded,
    path: POST_LOGIN_REDIRECT_ALLOWLIST[decoded],
  };
};
